<div class="container">
    <div class="container-content">
        <div class="container-main">
            <div class="container-list">
                <ul  [ngStyle]="items.length > 1 ? {'justify-content': 'space-between'} : {'justify-content': 'center'}">
                    <li class="certification"
                        *ngFor="let item of items" (click)="changeImage(item)"
                        [ngClass]="{'selected-pdf': selectedPdf === item}">
                            <div class="icon"></div>
                            <p class="body1">
                                {{item.document.title}}
                            </p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container-download">
            <a *ngIf="!pdfAtual" disabled class="ga-click" data-ga-reference="Fazer download">
                <app-mybutton ga="Fazer download" [download]="true" [disable]="true" [linkDownload]="selectedPdf" type="large" [text]="buttonLabel.btn_label"></app-mybutton>
            </a>
            <a *ngIf="pdfAtual" [href]="pdfAtual" [download]="pdfAtual" target="_blank" class="ga-click" [attr.data-ga-reference]="selectedPdf">
                <app-mybutton [download]="true" ga="Fazer download" [linkDownload]="selectedPdf" type="large" [text]="buttonLabel.btn_label"></app-mybutton>
            </a>
        </div>
    </div>
</div>
